/* ============================================================================
   MODEL SELECTOR — Figma 877:185201 (D 877:185202 · M 877:185215).
   A demo of the design: choosing a model moves the selected border and
   announces it, but the photography stays as it is. Cards are a radio group;
   arrows move focus and Enter / Space choose, like the size grid. Hover is the
   selected card's full black border plus the Homepage's image push-in.
   ========================================================================== */

import { animate, hover, stagger, MO, state, play, track, SPRING_RELEASE, $, $$ } from './mo.js';
import { createDrawer } from './drawers.js';
import { bindRoving, announce } from './ui.js';

const canHover = matchMedia('(hover: hover) and (pointer: fine)');

const cardHTML = (m, checked) => `
  <button class="ms-card" type="button" role="radio" aria-checked="${checked}" tabindex="${checked ? 0 : -1}"
    data-model="${m.id}" aria-label="${m.name}, ${m.size}. ${m.details.join(', ')}">
    <span class="ms-card__media"><img class="ms-card__img" src="${m.image}" alt="" width="120" height="150" loading="lazy" decoding="async"></span>
    <span class="ms-card__body" aria-hidden="true">
      <span class="ms-card__name">${m.name}—${m.size}</span>
      <span class="ms-card__details">${m.details.map((d) => `<span>${d}</span>`).join('')}</span>
    </span>
  </button>`;

export function initModelSelector({ models, selected }) {
  const root = $('[data-drawer="models"]');
  const drawer = createDrawer(root);
  const list = $('[data-ms-list]', root);
  $('[data-ms-count]', root).textContent = models.length;
  let current = selected;
  list.innerHTML = models.map((m) => cardHTML(m, m.id === current)).join('');
  const cards = $$('.ms-card', list);

  bindRoving(list, (card) => {
    const id = card.dataset.model;
    if (id === current) return;
    current = id;
    cards.forEach((c) => {
      const on = c.dataset.model === id;
      c.setAttribute('aria-checked', String(on));
      c.tabIndex = on ? 0 : -1;
    });
    play(card, { scale: [0.99, 1] }, SPRING_RELEASE);
    const m = models.find((x) => x.id === id);
    announce(`${m.name}, ${m.size}, selected`);
  }, { selectOnArrow: false });

  cards.forEach((card) => {
    const img = $('.ms-card__img', card);
    hover(card, () => {
      if (!canHover.matches || state.reduced) return undefined;
      track(animate(img, { scale: MO.scaleIn }, { duration: MO.slow, ease: MO.eEntrance }));
      return () => track(animate(img, { scale: 1 }, { duration: MO.slow, ease: MO.eEntrance }));
    });
  });

  return {
    open(trigger, { onDismiss } = {}) {
      cards.forEach((c) => c.toggleAttribute('data-autofocus', c.dataset.model === current));
      drawer.open(trigger, { onDismiss });
      if (!state.reduced) {
        play(cards, { opacity: [0, 1], y: [MO.riseSm, 0] },
          { duration: MO.slow, ease: MO.eEntrance, delay: stagger(MO.stagTight, { startDelay: 0.16 }) });
      }
    },
    close: () => drawer.close(),
    get isOpen() { return drawer.isOpen; },
  };
}
